import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Hero17 from '../components/hero17'
import Team3 from '../components/team3'
import Features24 from '../components/features24'
import CTA26 from '../components/cta26'
import Features25 from '../components/features25'
import Pricing14 from '../components/pricing14'
import BrokerageCharges from '../components/brokerage-charges'
import Testimonial17 from '../components/testimonial17'
import ContactForm3 from '../components/contact-form3'
import Footer4 from '../components/footer4'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Omshashvath Global Realty India Pvt Ltd</title>
        <meta property="og:title" content="Omshashvath Global Realty India Pvt Ltd" />
      </Helmet>

      <Navbar8
        link1={
          <Fragment>
            <span className="home-text100">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text101">Services</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text102">Directors</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="home-text103">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="home-text104">Virtual Tours</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="home-text105">Market Insights</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="home-text106">Contact Us</span>
          </Fragment>
        }
        link31={
          <Fragment>
            <span className="home-text107">Contact Us</span>
          </Fragment>
        }
        action1={
          <a href="#ContactForm3">
            <span className="home-text108">Contact Us</span>
          </a>
        }
        action2={
          <Fragment>
            <span className="home-text109">Secondary Action</span>
          </Fragment>
        }
        logoSrc="/cropped_image-1500h.png"
        page1Description={
          <Fragment>
            <span className="home-text110">
              Welcome to our property listing site
            </span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="home-text111">
              Explore our properties through virtual tours
            </span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="home-text112">
              Stay informed with the latest market trends
            </span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="home-text113">
              Get in touch with us for more information
            </span>
          </Fragment>
        }
        link1Url="#Hero17"
        link2Url="#Brokerage Charges"
        link3Url="#Team3"
        link3Url1="#ContactForm3"
      ></Navbar8>

      <Hero17
        action1={
          <a href="#Brokerage Charges">
            <span className="home-text114">Services</span>
          </a>
        }
        action2={
          <a href="#Brokerage Charges">
            <span className="home-text115">Brokerage Charges</span>
          </a>
        }
        content1={
          <Fragment>
            <span className="home-text116">
            "At Omshashvath Global Realty India Private Limited, we specialize in seamlessly connecting individuals with their ideal real estate solutions, whether it's a tranquil residential abode or a thriving commercial venture. Guided by principles of trust, transparency, and unwavering excellence, we are dedicated to making your real estate journey an enriching and rewarding experience. Whether you are buying, selling, or investing, we are your trusted partners, committed to providing exceptional service and achieving your real estate goals."
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text117">
            Omshashvath Global Realty India Pvt Ltd.
            </span>
          </Fragment>
        }
        hero17Id="Hero17"
      ></Hero17>

      <Team3
        
        text2={
          <Fragment>
            <span className="home-text121">
              <span>+91 7200151525</span>
              <br></br>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="home-text124">
              <span>shenoth@omshashvath.com</span>
              <br></br>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="home-text127">
              <span>repaka@omshashvath.com</span>
              <br></br>
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="home-text130">
              Driving excellence in real estate with unmatched expertise and a
              passion for delivering value.
            </span>
          </Fragment>
        }
        text21={
          <Fragment>
            <span className="home-text131">
              <span>+91 9841335248</span>
              <br></br>
            </span>
          </Fragment>
        }
        text22={
          <Fragment>
            <span className="home-text134">
              <span>+91 9445609145</span>
              <br></br>
            </span>
          </Fragment>
        }
        text31={
          <Fragment>
            <span className="home-text137">
              <span>rajkumars@omshashvath.com</span>
              <br></br>
            </span>
          </Fragment>
        }
       
        text211={
          <Fragment>
            <span className="home-text143">
              <span>+91 8939960345</span>
              <br></br>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text146">Meet Our Visionaries</span>
          </Fragment>
        }
        member12={
          <Fragment>
            <span className="home-text147">
              <span>Shenoth Raghavan</span>
              <br></br>
            </span>
          </Fragment>
        }
        member13={
          <Fragment>
            <span className="home-text150">
              <span>Satish Kumar Repaka</span>
              <br></br>
            </span>
          </Fragment>
        }
        member121={
          <Fragment>
            <span className="home-text153">
              <span>Rajkumar S</span>
              <br></br>
            </span>
          </Fragment>
        }
        member1Job={
          <Fragment>
            <span className="home-text156">Director</span>
          </Fragment>
        }
        member1Src="/whatsapp%20image%202025-01-02%20at%2020.55.03-200h.jpeg"
        member1Job2={
          <Fragment>
            <span className="home-text157">Director</span>
          </Fragment>
        }
        member1Job3={
          <Fragment>
            <span className="home-text158">
              <span>Vice president</span>
              <br></br>
            </span>
          </Fragment>
        }
        member1Src2="/whatsapp%20image%202025-01-02%20at%2020.55.28-200h.jpeg"
        member1Job21={
          <Fragment>
            <span className="home-text161">Director</span>
          </Fragment>
        }
        rootClassName="team3root-class-name"
        
        member1Content2={
          <Fragment>
            <span className="home-text163">
              Shenoth Raghavan possesses more than 16 years of vast experience
              in the buying, selling, and leasing of both commercial and
              residential properties, advisor for property management and
              customer service management. Excellent documentation and extensive
              experience in obtaining housing loans, project funding, and
              mortgage loans.
            </span>
          </Fragment>
        }
        member1Content3={
          <Fragment>
            <span className="home-text164">
            Satish Kumar Repaka is a seasoned real estate broker with 13 years of proven expertise in generating high-quality leads and closing deals, demonstrating a strong ability to self-source and execute transactions. He cultivates strong relationships within his extensive network and collaborates seamlessly with a team of professionals to achieve successful deal closures.
            </span> 
          </Fragment>
        }
        member1Content21={
          <Fragment>
            <span className="home-text165">
              <span>
                With 15 years of experience, Rajkumar specializes in arranging
                out-rate and joint development properties for builders. He is
                also skilled in handling various residential and commercial
                properties, along with facilitating loan arrangements for
                clients.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        team3Id="Team3"
      ></Team3>

      <Features24
        feature1Title={
          <Fragment>
            <span className="home-text168">Virtual Tours</span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text169">Contact Information</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text170">Market Insights</span>
          </Fragment>
        }
        rootClassName="features24root-class-name"
        feature1Description={
          <Fragment>
            <span className="home-text171">
              Explore properties through immersive virtual tours from the
              comfort of your home.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text172">
              Easily contact us for more information or to schedule a viewing.
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text173">
              Stay informed with market insights and trends.
            </span>
          </Fragment>
        }
      ></Features24>

      <CTA26
        action1={
          <Fragment>
            <span className="home-text174">Contact Us Now</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text175">
              Connecting you to the perfect property with trust, expertise, and
              care.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text176">Find Your Dream Property Today</span>
          </Fragment>
        }
      ></CTA26>

      <Features25
        feature1Title={
          <Fragment>
            <span className="home-text177">Property Listings</span>
          </Fragment>
        }
        feature2Title={
          <Fragment>
            <span className="home-text178">Virtual Tours</span>
          </Fragment>
        }
        feature3Title={
          <Fragment>
            <span className="home-text179">Market Insights</span>
          </Fragment>
        }
        rootClassName="features25root-class-name"
        feature1Description={
          <Fragment>
            <span className="home-text180">
              Browse through our extensive list of properties available for sale
              or rent.
            </span>
          </Fragment>
        }
        feature2Description={
          <Fragment>
            <span className="home-text181">
              Take virtual tours of properties from the comfort of your own
              home.
            </span>
          </Fragment>
        }
        feature3Description={
          <Fragment>
            <span className="home-text182">
              Stay informed with the latest market trends and insights to make
              informed decisions.
            </span>
          </Fragment>
        }
      ></Features25>

      <Pricing14
        plan1={
          <Fragment>
            <span className="home-text183">Basic plan</span>
          </Fragment>
        }
        plan3={
          <Fragment>
            <span className="home-text184">Enterprise plan</span>
          </Fragment>
        }
        plan11={
          <Fragment>
            <span className="home-text185">Basic plan</span>
          </Fragment>
        }
        plan12={
          <Fragment>
            <span className="home-text186">Basic plan</span>
          </Fragment>
        }
        plan21={
          <Fragment>
            <span className="home-text187">Business plan</span>
          </Fragment>
        }
        plan31={
          <Fragment>
            <span className="home-text188">Enterprise plan</span>
          </Fragment>
        }
        plan32={
          <Fragment>
            <span className="home-text189">Enterprise plan</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text190">
              Choose the perfect plan for you
            </span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="home-text191">
              <span>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text194">Pricing plan</span>
          </Fragment>
        }
        plan1Price={
          <Fragment>
            <span className="home-text195">$99/month</span>
          </Fragment>
        }
        plan3Price={
          <Fragment>
            <span className="home-text196">$299/month</span>
          </Fragment>
        }
        plan1Action={
          <Fragment>
            <span className="home-text197">Sign Up Now</span>
          </Fragment>
        }
        plan1Price1={
          <Fragment>
            <span className="home-text198">$200/yr</span>
          </Fragment>
        }
        plan1Price2={
          <Fragment>
            <span className="home-text199">$99/month</span>
          </Fragment>
        }
        plan1Yearly={
          <Fragment>
            <span className="home-text200">$999/year</span>
          </Fragment>
        }
        plan2Price1={
          <Fragment>
            <span className="home-text201">$299/yr</span>
          </Fragment>
        }
        plan3Action={
          <Fragment>
            <span className="home-text202">Sign Up Now</span>
          </Fragment>
        }
        plan3Price1={
          <Fragment>
            <span className="home-text203">$499/yr</span>
          </Fragment>
        }
        plan3Price2={
          <Fragment>
            <span className="home-text204">$299/month</span>
          </Fragment>
        }
        plan3Yearly={
          <Fragment>
            <span className="home-text205">$2999/year</span>
          </Fragment>
        }
        plan1Action1={
          <Fragment>
            <span className="home-text206">Get started</span>
          </Fragment>
        }
        plan1Action2={
          <Fragment>
            <span className="home-text207">Sign Up Now</span>
          </Fragment>
        }
        plan1Yearly1={
          <Fragment>
            <span className="home-text208">or $20 monthly</span>
          </Fragment>
        }
        plan1Yearly2={
          <Fragment>
            <span className="home-text209">$999/year</span>
          </Fragment>
        }
        plan2Action1={
          <Fragment>
            <span className="home-text210">Get started</span>
          </Fragment>
        }
        plan2Yearly1={
          <Fragment>
            <span className="home-text211">or $29 monthly</span>
          </Fragment>
        }
        plan3Action1={
          <Fragment>
            <span className="home-text212">Get started</span>
          </Fragment>
        }
        plan3Action2={
          <Fragment>
            <span className="home-text213">Sign Up Now</span>
          </Fragment>
        }
        plan3Yearly1={
          <Fragment>
            <span className="home-text214">or $49 monthly</span>
          </Fragment>
        }
        plan3Yearly2={
          <Fragment>
            <span className="home-text215">$2999/year</span>
          </Fragment>
        }
        plan1Feature1={
          <Fragment>
            <span className="home-text216">Property listing</span>
          </Fragment>
        }
        plan1Feature2={
          <Fragment>
            <span className="home-text217">Virtual tours</span>
          </Fragment>
        }
        plan1Feature3={
          <Fragment>
            <span className="home-text218">Market insights</span>
          </Fragment>
        }
        plan3Feature1={
          <Fragment>
            <span className="home-text219">Everything in Plan 2</span>
          </Fragment>
        }
        plan3Feature2={
          <Fragment>
            <span className="home-text220">Priority support</span>
          </Fragment>
        }
        plan3Feature3={
          <Fragment>
            <span className="home-text221">Custom branding</span>
          </Fragment>
        }
        plan3Feature4={
          <Fragment>
            <span className="home-text222">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature5={
          <Fragment>
            <span className="home-text223">Feature text goes here</span>
          </Fragment>
        }
        rootClassName="pricing14root-class-name"
        plan1Feature11={
          <Fragment>
            <span className="home-text224">Feature text goes here</span>
          </Fragment>
        }
        plan1Feature12={
          <Fragment>
            <span className="home-text225">Property listing</span>
          </Fragment>
        }
        plan1Feature21={
          <Fragment>
            <span className="home-text226">Feature text goes here</span>
          </Fragment>
        }
        plan1Feature22={
          <Fragment>
            <span className="home-text227">Virtual tours</span>
          </Fragment>
        }
        plan1Feature31={
          <Fragment>
            <span className="home-text228">Feature text goes here</span>
          </Fragment>
        }
        plan1Feature32={
          <Fragment>
            <span className="home-text229">Market insights</span>
          </Fragment>
        }
        plan2Feature11={
          <Fragment>
            <span className="home-text230">Feature text goes here</span>
          </Fragment>
        }
        plan2Feature21={
          <Fragment>
            <span className="home-text231">Feature text goes here</span>
          </Fragment>
        }
        plan2Feature31={
          <Fragment>
            <span className="home-text232">Feature text goes here</span>
          </Fragment>
        }
        plan2Feature41={
          <Fragment>
            <span className="home-text233">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature11={
          <Fragment>
            <span className="home-text234">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature12={
          <Fragment>
            <span className="home-text235">Everything in Plan 2</span>
          </Fragment>
        }
        plan3Feature21={
          <Fragment>
            <span className="home-text236">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature22={
          <Fragment>
            <span className="home-text237">Priority support</span>
          </Fragment>
        }
        plan3Feature31={
          <Fragment>
            <span className="home-text238">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature32={
          <Fragment>
            <span className="home-text239">Custom branding</span>
          </Fragment>
        }
        plan3Feature41={
          <Fragment>
            <span className="home-text240">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature42={
          <Fragment>
            <span className="home-text241">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature51={
          <Fragment>
            <span className="home-text242">Feature text goes here</span>
          </Fragment>
        }
        plan3Feature52={
          <Fragment>
            <span className="home-text243">Feature text goes here</span>
          </Fragment>
        }
      ></Pricing14>

      <BrokerageCharges
        step1Title={
          <Fragment>
            <span className="home-text244">
              City Limits – Residential / Commercial
            </span>
          </Fragment>
        }
        step2Title={
          <Fragment>
            <span className="home-text245">Outside City Limits</span>
          </Fragment>
        }
        step3Title={
          <Fragment>
            <span className="home-text246">
              Sale of Industrial Land / Building &amp; Agricultural Land Outside
              City Limits
            </span>
          </Fragment>
        }
        step4Title={
          <Fragment>
            <span className="home-text247">Joint Venture Development</span>
          </Fragment>
        }
        rootClassName="brokerage-chargesroot-class-name"
        step1Description={
          <Fragment>
            <span className="home-text248">
              2% on the sale consideration from each party we represent.
            </span>
          </Fragment>
        }
        step2Description={
          <Fragment>
            <span className="home-text249">
              3% on the sale consideration from each party we represent.
            </span>
          </Fragment>
        }
        step3Description={
          <Fragment>
            <span className="home-text250">
              4% on the sale consideration from each party we represent.
            </span>
          </Fragment>
        }
        step4Description={
          <Fragment>
            <span className="home-text251">
              2% commission each from the developer/owner on the total land
              value.
            </span>
          </Fragment>
        }
        brokerageChargesId="Brokerage Charges"
      ></BrokerageCharges>

      <Testimonial17
        review1={
          <Fragment>
            <span className="home-text252">
              I have been using this platform for a while now, and it has made
              property hunting so much easier for me. The virtual tours are a
              game-changer!
            </span>
          </Fragment>
        }
        review2={
          <Fragment>
            <span className="home-text253">
              I found my dream home through this site, and the market insights
              provided were invaluable in making an informed decision. Highly
              recommended!
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text254">
              As a property developer, having a platform that showcases my
              listings with virtual tours is fantastic. It has increased the
              visibility of my properties.
            </span>
          </Fragment>
        }
        review4={
          <Fragment>
            <span className="home-text255">
              Managing rental properties can be challenging, but this site has
              simplified the process for me. The contact information feature is
              very convenient.
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text256">
              Read what our clients have to say about their experience with our
              property listing services.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text257">Testimonials</span>
          </Fragment>
        }
        author1Name={
          <Fragment>
            <span className="home-text258">John Doe</span>
          </Fragment>
        }
        author2Name={
          <Fragment>
            <span className="home-text259">Jane Smith</span>
          </Fragment>
        }
        author3Name={
          <Fragment>
            <span className="home-text260">David Johnson</span>
          </Fragment>
        }
        author4Name={
          <Fragment>
            <span className="home-text261">Sarah Brown</span>
          </Fragment>
        }
        rootClassName="testimonial17root-class-name"
        author1Position={
          <Fragment>
            <span className="home-text262">Real Estate Investor</span>
          </Fragment>
        }
        author2Position={
          <Fragment>
            <span className="home-text263">Home Buyer</span>
          </Fragment>
        }
        author3Position={
          <Fragment>
            <span className="home-text264">Property Developer</span>
          </Fragment>
        }
        author4Position={
          <Fragment>
            <span className="home-text265">Rental Manager</span>
          </Fragment>
        }
      ></Testimonial17>

      <ContactForm3
        text={
          <Fragment>
            <span className="home-text266">
              We&apos;re here to help you find the property of your dreams.
              Reach out today!
            </span>
          </Fragment>
        }
        action={
          <Fragment>
            <span className="home-text267">Submit</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text268">Contact us</span>
          </Fragment>
        }
        rootClassName="contact-form3root-class-name"
        contactForm3Id="ContactForm3"
      ></ContactForm3>
      
      <Footer4
        link1={
          <a href='#Hero17'>
            <span className="home-text269">Home</span>
          </a>
        }
        link2={
          <a href='#Brokerage Charges'>
            <span className="home-text270">Services</span>
          </a>
        }
        link3={
          <a href='#ContactForm3'>
            <span className="home-text271">Contact Us</span>
          </a>
        }
        link4={
          <a href='#Team3'>
            <span className="home-text272">Directors</span>
          </a>
        }
        link5={
          <a href='#Brokerage Charges'>
            <span className="home-text273">Brokerage Charges</span>
          </a>
        }
        termsLink={
          <Fragment>
            <span className="home-text274">Terms of Use</span>
          </Fragment>
        }
        cookiesLink={
          <Fragment>
            <span className="home-text275">Cookies Policy</span>
          </Fragment>
        }
        privacyLink={
          <Fragment>
            <span className="home-text276">Privacy Policy</span>
          </Fragment>
        }
        rootClassName="footer4root-class-name"
      ></Footer4>
    </div>
  )
}

export default Home
